// Category filter component for filtering products by category
import React from 'react';
import { ProductCategory } from '../types';
import { CATEGORY_METADATA } from '../shared/categories';
import './CategoryFilter.css';

interface CategoryFilterProps {
    selectedCategory: ProductCategory | 'all';
    onCategoryChange: (category: ProductCategory | 'all') => void;
    availableCategories: ProductCategory[];
    onScrollToProducts?: () => void;
}

const CategoryFilter: React.FC<CategoryFilterProps> = ({
    selectedCategory,
    onCategoryChange,
    availableCategories,
    onScrollToProducts,
}) => {
    const handleCategoryClick = (category: ProductCategory | 'all') => {
        onCategoryChange(category);
        if (onScrollToProducts) {
            // Use setTimeout to ensure state update happens first
            setTimeout(() => {
                onScrollToProducts();
            }, 50);
        }
    };

    // Split categories into odd and even for mobile two-row layout
    const allCategories: Array<ProductCategory | 'all'> = ['all', ...availableCategories];
    const firstRow = allCategories.filter((_, index) => index % 2 === 0);
    const secondRow = allCategories.filter((_, index) => index % 2 === 1);

    const renderButton = (category: ProductCategory | 'all') => {
        const isAll = category === 'all';
        const metadata = isAll ? null : CATEGORY_METADATA[category];

        return (
            <button
                key={category}
                className={`category-btn ${selectedCategory === category ? 'active' : ''}`}
                onClick={() => handleCategoryClick(category)}
            >
                <span className="category-label">
                    {isAll ? 'All' : metadata!.shortLabel}
                </span>
            </button>
        );
    };

    return (
        <div className="category-filter">
            <div className="category-buttons">
                <div className="category-row">
                    {firstRow.map(renderButton)}
                </div>
                <div className="category-row">
                    {secondRow.map(renderButton)}
                </div>
            </div>
        </div>
    );
};

export default CategoryFilter;
